import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './i18n';
import App from './App';
import { AppErrorBoundary, reloadOnce } from './components/AppErrorBoundary';

// Vite не смог догрузить чанк (старая вкладка после деплоя, сеть моргнула) —
// одна перезагрузка подтянет свежий index.html вместо белого экрана.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnce()) event.preventDefault();
});

if ('serviceWorker' in navigator) {
  registerSW({ immediate: true });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
